import { route } from 'frontend/inertia/routes'

export const usersPath = {
  // mirrors frontend_academy_partner_users
  index: route('/academy_partner/users'),
  // mirrors new_frontend_academy_partner_user
  new: route('/academy_partner/users/new'),
  // mirrors frontend_academy_partner_user
  show: route('/academy_partner/users/:id'),
  // mirrors edit_frontend_academy_partner_user
  edit: route('/academy_partner/users/:id/edit'),
}
